const devEnvConstants = {
  // apiUrl: 'http://203.69.248.109:18124',
  apiUrl: 'http://10.224.1.41/ensure/api',
  getSuccessCode: 200,
  postSuccessCode: 201,
  loginCount: 3,
  defaultProgramId: 'original',
  gtmId: 'GTM-K84GLHDF',
  featureToggle: true
};

export default devEnvConstants;
